import React, { Component, createRef } from 'react';
import { withRouter } from 'react-router-dom';
import withStyles from 'react-jss';
import { connect } from 'react-redux';
import { Translation } from 'react-i18next';
import i18n from 'i18next';
import Scrollbar from '../Scrollbar';
import { getPreRegistrationState, getTenantState } from '../../store/selectors';
import { addTerms } from '../../store/actions';
import RouteBack from '../utility/RouteBack';
import { termsandconditions } from '../../copy/onboardingCopy.json';
import CampusBackground from '../CampusBackground';
import { fireGTM } from '../../gtm/gtmUtil';
import { termsPage_GTM } from '../../gtm/datalayers/termsDataLayers.json';
import { nextButton_GTM } from '../../gtm/datalayers/utilDataLayers.json';
import WindowTitle from '../utility/WindowTitle';
import ReactHtmlParser from 'react-html-parser';

const agreeButtonStyles = {
  color: (props) => ({
    backgroundColor: props.tenant.primary,
    borderColor: props.tenant.primary,

    '&:hover': {
      backgroundColor: 'white',
      border: `2px solid ${props.tenant.primary}`,
      color: props.tenant.primary,
      borderStyle: 'solid',
    },
  }),
  check: (props) => ({
    '&:checked+span::before': {
      border: `solid ${props.tenant.primary}`,
    },
  }),
};

const getPersonalDataItems = (tenantName) => {
  switch (tenantName) {
    case 'Baobab':
      return [
        'First name',
        'Last name',
        'Your Email Address',
        'Year of your high school graduation',
        'Your highest level of education',
      ];
    default:
      return [
        'First name',
        'Last name',
        'Birth Date',
        'Your Email Address',
        'Name of your high school',
        'Year of your high school graduation',
        'Your highest level of education',
      ];
  }
};

const getAsuTermsCopy = () => ({
  header1: i18n.t('Terms and conditions'),
  header2: i18n.t('Do you agree to the following?'),
  heading1: i18n.t('TERMS OF USE & PRIVACY POLICY'),
  line2: i18n.t(
    'PLEASE READ ALL OF THE FOLLOWING CAREFULLY BECAUSE THESE TERMS OF USE & ASU’S PRIVACY POLICY GOVERNS YOUR USE OF ME3®.'
  ),
  line3: i18n.t(
    'IF YOU DO NOT WANT TO CONSENT TO THESE TERMS, PLEASE DO NOT PROVIDE YOUR PERSONAL DATA OR USE ME3®.'
  ),
  line4: i18n.t('BY CLICKING ON THE “I CONSENT” BELOW, YOU CONSENT TO:'),
  bullet1: i18n.t(
    'ASU is using the Personal and Preference Data you provide to interact with you regarding any information you request. As a public nonprofit institution, we will not sell user data collected from me3 users.'
  ),
  bullet2: i18n.t(
    "The most recent terms ofa <a rel='noreferrer noopener' target='_blank' href='https://www.asu.edu/privacy/'>ASU'S PRIVACY STATEMENT</a>"
  ),
  bullet3: i18n.t('The me3® TERMS OF USE & PRIVACY POLICY as set forth below.'),
  line5: i18n.t(
    'Please do not submit Personal Data or use me3® if you do not wish to provide your consent.'
  ),
  line6: i18n.t(
    'ASU MAY MODIFY THESE POLICY TERMS FROM TIME TO TIME IN OUR SOLE DISCRETION AND WITHOUT NOTICE TO YOU, OTHER THAN WE WILL POST THE MOST RECENT REVISION DATE AT THE END OF THIS POLICY. YOUR CONTINUED USE OF ME3® AFTER ANY MODIFICATION OF THIS POLICY MEANS YOU HAVE ACCEPTED THE MODIFICATIONS.'
  ),
  heading2: i18n.t('Overview of me3®'),
  line7: i18n.t(
    'The Arizona Board of Regents for and on behalf of Arizona State University (ASU, us, or we) developed me3®, an online, cloud-based, tool that helps students identify potential careers and college majors and gives them insight on what academic paths will help them meet their personal academic and career goals.'
  ),
  heading3: i18n.t('What Data me3® Collects:'),
  line8: i18n.t(
    'me3® asks you a series of questions that help us identify potential careers and college majors for you (your Preference Data). None of your responses require you to reveal any personal information. We use your answers to analyze and provide you information regarding potential careers and college majors.'
  ),
  line9: i18n.t(
    'In addition, to use me3® , we require you to provide us with the following personal information (Personal Data):'
  ),
  personalDataItems: getPersonalDataItems('ASU'),
  heading4: i18n.t('How We Use your me3® Data:'),
  line10: i18n.t(
    'ASU uses your Preference Data to provide you suggestions regarding potential careers and college majors identified via your use of me3®. We may also use your Preference and Personal Data to provide you information regarding applying to ASU, specific courses and programs offered by ASU that may be of interest to you based on the results of your me3® use, and to send you updates and information regarding ASU.'
  ),
  line11: i18n.t(
    'We may also: archive your Preference and Personal Data; use it for research and analytics purposes; use it for future communications with you if you consent; use it to establish, exercise, and defend legal claims; use it for reasons of substantial public interest, including archiving purposes; and use it for historical, scientific, research, or statistical purposes, subject to appropriate safeguards. We may also use your Preference and Personal Data for the legitimate interests of ASU and any third party to which ASU discloses your Preference and Personal Data, if your fundamental rights and freedoms do not override those interests. When reasonably possible, we process your Preference and Personal Data on an anonymized, pseudo anonymized, and/or de-identified basis.'
  ),
  line12: i18n.t(
    'We may also use your Preference and Personal Data to communicate with your school if we have a contract with your school or district, to help your school develop, update, and track student career plans and information, both on an aggregate and individual basis, including for Education and Career Action Plans (ECAPs) that meet the requirements adopted by the Arizona State Board of Education (the Dashboard). If your school uses the Dashboard, your consent to this Policy includes a consent to allow ASU to share your Preference and Personal Data with your school. If you are an ASU student, we may also share your Preference and Personal Data with your advisors, success coaches, and any other individuals involved with your academic success.  We do not allow any schools to share your Personal Data unless allowed by law.'
  ),
  line13: i18n.t(
    'me3® is available for use by all people, other than those in Balkans, Belarus, Burundi, Central African Republic, Cuba, Darfur, Democratic Republic of the Congo, Eriteria, Iran, Iraq, Lebanon, Libya, Mali, Nicaragua, North Korea, Russia, Somalia, South Sudan, Sudan, Syria, Ukraine, Venezuela, Yemen and Zimbabwe. Your agreement to this Policy indicates that you are not in any of these countries. If you are in a country or jurisdiction, such as the European Union, that has laws that protect your personal data or information, your consent as indicated above allows our use and collection of your Preference and Personal Data as set forth in this Policy.'
  ),
  heading5: i18n.t('Cookies'),
  line14: i18n.t(
    'Cookies are small files that are stored on your computing devices. We use cookies to understand and save your preferences for future visits and compile aggregate data about network traffic and network interaction so that we can offer better network experiences and tools in the future. Cookies may be set by organizations other than ASU. Because the cookie policies of these third party service providers may change over time, you should review their policies by visiting their privacy policies directly. You may disable cookies through your individual browser options. However, if you do not accept cookies, you may not be able to use some portions of me3®. me3® does not use cookies for online profiling or targeted commercial advertising.'
  ),
  line15: i18n.t(
    'The following describes the types of cookies ASU uses with me3®:'
  ),
  heading6: i18n.t('Required or Strictly Necessary Cookies'),
  line16: i18n.t(
    'These cookies are essential for me3® to operate correctly and to provide you with requested services. For example, we use cookies to authenticate you, so when you log on to me3® , we know who you are.'
  ),
  heading7: i18n.t('Functionality Cookies'),
  line17: i18n.t(
    'We use functionality cookies to enhance me3® features, and for personalization, such as storing your preferences (e.g. username and language selection). Functionality cookies may be set by ASU or by third parties whose services we have added to me3®. If you do not allow these cookies, you may not be able to use some portions of me3® , and some me3® functions may not work properly.'
  ),
  heading8: i18n.t('Social Media Cookies'),
  line18: i18n.t(
    'Social media cookies may be set by third parties such as YouTube and Facebook to collect information about your social media usage.'
  ),
  heading9: i18n.t('Analytics Cookies'),
  line19: i18n.t(
    'Analytics cookies collect information about your use of me3® and help us improve the way it works. For example, analytics cookies identify the most frequently visited pages, record any difficulties you have, and show whether our advertising is effective. This allows us to see the overall patterns of usage of me3® , rather than the usage of a single person.'
  ),
  heading10: i18n.t('Do Not Track Signals'),
  line20: i18n.t(
    'Some web browsers (such as Safari, Internet Explorer, Firefox and Chrome) have a “Do Not Track” (DNT) feature that tells websites that users do not want to have their online activity tracked. Not all browsers offer a DNT option and DNT signals are not yet uniform. For this reason, ASU does not respond to DNT signals.'
  ),
  heading11: i18n.t('General Terms'),
  line21: i18n.t(
    'We reserve the right to suspend or discontinue your use of me3 if you use, or we suspect you use, me3® in a manner inconsistent with this Policy or any applicable laws, rules, and regulations. In addition to suspension or discontinuance of your use of me3® , we may take appropriate administrative and/or legal action, as we deem necessary.'
  ),
  line22: i18n.t(
    'ASU’s failure to enforce any provision of this Policy will not constitute a waiver of any other provision.'
  ),
  line23: i18n.t(
    'All questions or disputes regarding me3® or this Policy will be resolved by ASU in its sole discretion. Please direct questions or disputes to me3@asu.edu. All decisions made by ASU or its designated agents regarding me3® , your use of me3® , and this Policy are final.'
  ),
  line24: i18n.t(
    'Your use of me3® is subject to all applicable laws and regulations.'
  ),
  heading12: i18n.t('Limitation of Liability; Warranties; Disputes'),
  line25: i18n.t(
    'ASU is not responsible for technical, network, electronic, computer, hardware or software malfunctions, or inaccurate transmission of data, including, errors or difficulties that may occur in connection with the administration of me3® or communicating with you. ASU is also not responsible for any incorrect or inaccurate information, whether caused by me3® users, tampering, hacking, or by any equipment or programming associated with or used in me3®.'
  ),
  line26: i18n.t(
    'You accept all responsibility for, and hereby release ASU of and from, any claims, liabilities, damages or expenses that may arise from your use of me3® , or for any harm or injury caused by your use of me3®.'
  ),
  line27: i18n.t(
    'UNDER NO CIRCUMSTANCES, IS ASU LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL OR CONSEQUENTIAL DAMAGES ARISING OUT OF YOUR USE OF ME3® , EVEN IF ASU HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.'
  ),
  line28: i18n.t(
    'ASU DISCLAIMS ANY REPRESENTATIONS OR WARRANTIES, EXPRESSED OR IMPLIED, REGARDING ME3® , INCLUDING WARRANTIES OF FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT'
  ),
  line29: i18n.t(
    'This policy will be governed by the laws of the State of Arizona without regard to any conflicts of laws principles. ASU’s obligations are subject to the regulations/policies of the Arizona Board of Regents. Any proceeding arising out of or relating to this Agreement or your use of me3® will be conducted in Maricopa County, Arizona. You consent to such jurisdiction, and waive any objection you may have to venue or convenience of forum.'
  ),
  closerEffectiveText: 'Effective',
  closerUpdatedText: 'Updated',
  checkbox1: i18n.t('I consent'),
  checkbox2: i18n.t('I am 13 years or older'),
  mobileScrollPromptText: i18n.t('Scroll Down'),
});

/* eslint-disable react/jsx-one-expression-per-line */
const getSassTermsCopy = (tenant) => ({
  header1: i18n.t('Terms and conditions'),
  header2: i18n.t('Do you agree to the following?'),
  heading1: i18n.t('TERMS OF USE & PRIVACY POLICY'),
  line2: i18n.t(
    'PLEASE READ ALL OF THE FOLLOWING CAREFULLY BECAUSE THESE TERMS OF USE & ASU’S PRIVACY POLICY GOVERNS YOUR USE OF ME3®.'
  ),
  line3: i18n.t(
    'IF YOU DO NOT WANT TO CONSENT TO THESE TERMS, PLEASE DO NOT PROVIDE YOUR PERSONAL DATA OR USE ME3®.'
  ),
  line4: i18n.t('BY CLICKING ON THE “I CONSENT” BELOW, YOU CONSENT TO:'),
  bullet1: i18n.t(
    `ASU is using the Personal and Preference Data you provide to identify preferred career choices and to be shared with {{tenantName}}. As a public nonprofit institution, ASU will not sell user data collected from me3 users.`,
    { tenantName: tenant.terms_info.name }
  ),
  bullet2: i18n.t(
    "The most recent terms of <a rel='noreferrer noopener' target='_blank' href='https://www.asu.edu/about/privacy'>ASU'S PRIVACY STATEMENT</a>, including the <a rel='noreferrer noopener' target='_blank'  href='https://www.asu.edu/about/privacy'>ASU'S European Supplement</a> (if you are covered by GDPR)."
  ),
  bullet3: i18n.t('The me3® TERMS OF USE & PRIVACY POLICY as set forth below.'),
  line5: i18n.t(
    'Please do not submit Personal Data or use me3® if you do not wish to provide your consent.'
  ),
  line6: i18n.t(
    'ASU MAY MODIFY THESE POLICY TERMS FROM TIME TO TIME IN OUR SOLE DISCRETION AND WITHOUT NOTICE TO YOU, OTHER THAN WE WILL POST THE MOST RECENT REVISION DATE AT THE END OF THIS POLICY. YOUR CONTINUED USE OF ME3® AFTER ANY MODIFICATION OF THIS POLICY MEANS YOU HAVE ACCEPTED THE MODIFICATIONS.'
  ),
  heading2: i18n.t('Overview of me3®'),
  line7: i18n.t(
    'The Arizona Board of Regents for and on behalf of Arizona State University (ASU, us, or we) developed me3®, an online, cloud-based, tool that helps students identify potential careers and college majors and gives them insight on what academic paths will help them meet their personal academic and career goals.'
  ),
  heading3: i18n.t('What Data me3® Collects:'),
  line8: i18n.t(
    'me3® asks you a series of questions that help us identify potential careers and college majors for you (your Preference Data). None of your responses require you to reveal any personal information. We use your answers to analyze and provide you information regarding potential careers and college majors.'
  ),
  line9: i18n.t(
    'In addition, to use me3® , we require you to provide us with the following personal information (Personal Data):'
  ),
  personalDataItems: getPersonalDataItems(tenant.name),
  heading4: i18n.t('How We Use your me3® Data:'),
  line10: i18n.t(
    'ASU uses your Preference Data to provide you suggestions regarding potential careers and college majors identified via your use of me3®. We may also use your Preference and Personal Data to provide you information regarding applying to ASU, specific courses and programs offered by ASU that may be of interest to you based on the results of your me3® use, and to send you updates and information regarding ASU.'
  ),
  line11: i18n.t(
    'We may also: archive your Preference and Personal Data; use it for research and analytics purposes; use it for future communications with you if you consent; use it to establish, exercise, and defend legal claims; use it for reasons of substantial public interest, including archiving purposes; and use it for historical, scientific, research, or statistical purposes, subject to appropriate safeguards. We may also use your Preference and Personal Data for the legitimate interests of ASU and any third party to which ASU discloses your Preference and Personal Data, if your fundamental rights and freedoms do not override those interests. When reasonably possible, we process your Preference and Personal Data on an anonymized, pseudo anonymized, and/or de-identified basis.'
  ),
  line12: i18n.t(
    'Your consent to this Policy includes a consent to allow ASU to share your Preference and Personal Data with {{tenantName}}. If you are an ASU student, we may also share your Preference and Personal Data with your advisors, success coaches, and any other individuals involved with your academic success. We do not allow any schools to share your Personal Data with third parties unless allowed by law.',
    { tenantName: tenant.terms_info.name }
  ),
  line13: i18n.t(
    'me3® is available for use by all people. If you are in a country or jurisdiction, such as the European Union, that has laws that protect your personal data or information, your consent as indicated above allows our use and collection of your Preference and Personal Data as set forth in this Policy.'
  ),
  heading5: i18n.t('Cookies'),
  line14: i18n.t(
    'Cookies are small files that are stored on your computing devices. We use cookies to understand and save your preferences for future visits and compile aggregate data about network traffic and network interaction so that we can offer better network experiences and tools in the future. Cookies may be set by organizations other than ASU. Because the cookie policies of these third party service providers may change over time, you should review their policies by visiting their privacy policies directly. You may disable cookies through your individual browser options. However, if you do not accept cookies, you may not be able to use some portions of me3®. me3® does not use cookies for online profiling or targeted commercial advertising.'
  ),
  line15: i18n.t(
    'The following describes the types of cookies ASU uses with me3®:'
  ),
  heading6: i18n.t('Required or Strictly Necessary Cookies'),
  line16: i18n.t(
    'These cookies are essential for me3® to operate correctly and to provide you with requested services. For example, we use cookies to authenticate you, so when you log on to me3® , we know who you are.'
  ),
  heading7: i18n.t('Functionality Cookies'),
  line17: i18n.t(
    'We use functionality cookies to enhance me3® features, and for personalization, such as storing your preferences (e.g. username and language selection). Functionality cookies may be set by ASU or by third parties whose services we have added to me3®. If you do not allow these cookies, you may not be able to use some portions of me3® , and some me3® functions may not work properly.'
  ),
  heading8: i18n.t('Social Media Cookies'),
  line18: i18n.t(
    'Social media cookies may be set by third parties such as YouTube and Facebook to collect information about your social media usage.'
  ),
  heading9: i18n.t('Analytics Cookies'),
  line19: i18n.t(
    'Analytics cookies collect information about your use of me3® and help us improve the way it works. For example, analytics cookies identify the most frequently visited pages, record any difficulties you have, and show whether our advertising is effective. This allows us to see the overall patterns of usage of me3® , rather than the usage of a single person.'
  ),
  heading10: i18n.t('Do Not Track Signals'),
  line20: i18n.t(
    'Some web browsers (such as Safari, Internet Explorer, Firefox and Chrome) have a “Do Not Track” (DNT) feature that tells websites that users do not want to have their online activity tracked. Not all browsers offer a DNT option and DNT signals are not yet uniform. For this reason, ASU does not respond to DNT signals.'
  ),
  heading11: i18n.t('General Terms'),
  line21: i18n.t(
    'We reserve the right to suspend or discontinue your use of me3 if you use, or we suspect you use, me3® in a manner inconsistent with this Policy or any applicable laws, rules, and regulations. In addition to suspension or discontinuance of your use of me3® , we may take appropriate administrative and/or legal action, as we deem necessary.'
  ),
  line22: i18n.t(
    'ASU’s failure to enforce any provision of this Policy will not constitute a waiver of any other provision.'
  ),
  line23: i18n.t(
    'All questions or disputes regarding me3® or this Policy will be resolved by ASU in its sole discretion. Please direct questions or disputes to me3@asu.edu. All decisions made by ASU or its designated agents regarding me3® , your use of me3® , and this Policy are final.'
  ),
  line24: i18n.t(
    'Your use of me3® is subject to all applicable laws and regulations.'
  ),
  heading12: i18n.t('Limitation of Liability; Warranties; Disputes'),
  line25: i18n.t(
    'ASU is not responsible for technical, network, electronic, computer, hardware or software malfunctions, or inaccurate transmission of data, including, errors or difficulties that may occur in connection with the administration of me3® or communicating with you. ASU is also not responsible for any incorrect or inaccurate information, whether caused by me3® users, tampering, hacking, or by any equipment or programming associated with or used in me3®.'
  ),
  line26: i18n.t(
    'You accept all responsibility for, and hereby release ASU of and from, any claims, liabilities, damages or expenses that may arise from your use of me3® , or for any harm or injury caused by your use of me3®.'
  ),
  line27: i18n.t(
    'UNDER NO CIRCUMSTANCES, IS ASU LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL OR CONSEQUENTIAL DAMAGES ARISING OUT OF YOUR USE OF ME3® , EVEN IF ASU HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.'
  ),
  line28: i18n.t(
    'ASU DISCLAIMS ANY REPRESENTATIONS OR WARRANTIES, EXPRESSED OR IMPLIED, REGARDING ME3® , INCLUDING WARRANTIES OF FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT'
  ),
  line29: i18n.t(
    'This policy will be governed by the laws of the State of Arizona without regard to any conflicts of laws principles. ASU’s obligations are subject to the regulations/policies of the Arizona Board of Regents. Any proceeding arising out of or relating to this Agreement or your use of me3® will be conducted in Maricopa County, Arizona. You consent to such jurisdiction, and waive any objection you may have to venue or convenience of forum.'
  ),
  closerEffectiveText: i18n.t('Effective'),
  checkbox1: i18n.t('I consent'),
  checkbox2: i18n.t('I am 13 years or older'),
  mobileScrollPromptText: i18n.t('Scroll Down'),
});

class Terms extends Component {
  constructor(props) {
    super(props);
    this.state = { termsandconditions: getSassTermsCopy(this.props.tenant) };
    this.checkRef = createRef();
    this.goToGameExamplePage = this.goToGameExamplePage.bind(this);
    this.handleScrollDownSelect = this.handleScrollDownSelect.bind(this);
    this.handleTermsCheck = this.handleTermsCheck.bind(this);
  }
  // TODO:Ability to read/save the version number of the current terms and conditions

  componentDidMount() {
    const { tenant } = this.props;
    return tenant.name === 'ASU'
      ? this.setState({ termsandconditions: getAsuTermsCopy() })
      : this.setState({
          termsandconditions: getSassTermsCopy(this.props.tenant),
        });
  }

  getDynamicStyle = () => {
    return this.props.preregistration.agreedToTerms
      ? this.props.classes.color
      : null;
  };

  goToGameExamplePage() {
    fireGTM(nextButton_GTM, 'agree', 'terms and conditions');

    const { history } = this.props;

    if (history) history.push('game-landing');
  }

  handleScrollDownSelect() {
    fireGTM(termsPage_GTM.consent);
    this.checkRef.current.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  }

  handleTermsCheck() {
    const { preregistration } = this.props;

    fireGTM(termsPage_GTM.consent);

    if (!preregistration.agreedToTerms) {
      this.props.addTerms({
        agreedToTerms: true,
        termsVersionNumber: preregistration.termsVersionNumber,
      });
    } else {
      this.props.addTerms({
        agreedToTerms: false,
        termsVersionNumber: preregistration.termsVersionNumber,
      });
    }
  }

  getEffectiveDate = (state) => {
    // DEV NOTE: These are based on the tenant's launch date
    const effectiveDateMonth =
      this.props.tenant.terms_info.effective_date_month;
    const effectiveDateYear = this.props.tenant.terms_info.effective_date_year;
    const effectiveFullText = `${
      state.termsandconditions?.closerEffectiveText
    }: ${
      i18n.language === 'fr' ? 'février' : effectiveDateMonth
    }, ${effectiveDateYear}`;

    return effectiveFullText;
  };

  getUpdatedDate = (state) => {
    const updatedDateMonth =
      this.props.tenant.terms_info.updated_date_month || '';
    const updatedDateYear =
      this.props.tenant.terms_info.updated_date_year || '';
    const updatedFullText = state.termsandconditions.closerUpdatedText
      ? `${state.termsandconditions?.closerUpdatedText}: ${updatedDateMonth}, ${updatedDateYear}`
      : '';

    return updatedFullText;
  };

  render() {
    const { preregistration, tenant } = this.props;
    const checkBoxColor = {
      color: tenant.primary,
    };
    const scrollLinkTextColor = {
      color: tenant.primary,
    };
    const checkboxBorder = {
      border: `1px solid ${tenant.primary}`,
    };
    const primaryBorderLarge = {
      bordertop: `5px solid ${tenant.primary}`,
    };
    const yellowBarColor = {
      backgroundColor: tenant.secondary,
    };

    const secondaryBorderLarge = {
      borderTop: `11px solid ${this.props.tenant.secondary}`,
    };

    const getMainContent = (t) => (
      <div className="terms">
        {/* -------------- Top Section -------------- */}
        <div className="red-border" style={primaryBorderLarge} />
        <div className="secondary-border-mobile" style={secondaryBorderLarge} />
        <div className="columns top-section-container is-multiline is-mobile">
          <div className="column top-left is-narrow">
            <RouteBack
              color={tenant.primary}
              route="/onboarding/location"
              tenant={this.props.tenant}
              section="terms and conditions"
              text="back"
            />
          </div>
          <div className="header-text-yellow-line-container">
            <div className="header-text-container has-text-centered">
              <h1>{this.state.termsandconditions.header1}</h1>
              <h2>{this.state.termsandconditions.header2}</h2>
            </div>
            <div className="yellow-line-container">
              <hr className="yellow-line" style={yellowBarColor} />
            </div>
          </div>
          <div className="header-horizontal-line-container">
            <div className="grey-horizontal-line" />
          </div>
        </div>
        {/* -------------- Middle Section -------------- */}
        <div className="text-box">
          <div className="columns is-multiline is-centered scroll-container">
            <Scrollbar contentClassName="text-box-scrollbar">
              <div className="terms-copy">
                <h2 className="terms-main-header spaced">
                  {this.state.termsandconditions.heading1}
                </h2>
                <p className="terms-paragraph spaced">
                  {this.state.termsandconditions.line2}
                </p>
                <p className="terms-paragraph soaced">
                  {this.state.termsandconditions.line3}
                </p>
                <h2 className="terms-header-underline">
                  {this.state.termsandconditions.line4}
                </h2>
                <ol className="bullets">
                  <li className="terms-bullet-item">
                    1. {ReactHtmlParser(this.state.termsandconditions.bullet1)}
                  </li>
                  <li className="terms-bullet-item">
                    2. {ReactHtmlParser(this.state.termsandconditions.bullet2)}
                  </li>
                  <li className="terms-bullet-item">
                    3. {this.state.termsandconditions.bullet3}
                  </li>
                  {tenant.name === 'ASU' && (
                    <li className="terms-bullet-item">
                      <>
                        4. If you are in the European Union or another country
                        or state that has adopted the GDPR (General Data
                        Protection Regulation) or similar privacy protection,
                        please also read the
                        <a
                          rel="noreferrer noopener"
                          target="_blank"
                          href="https://www.asu.edu/privacy/"
                        >
                          {' '}
                          ASU European Supplement to ASU’s Privacy Statement to
                          understand your rights and responsibilities. Please do
                          not submit Personal Data or use{' '}
                        </a>
                        me3®
                        <a
                          rel="noreferrer noopener"
                          target="_blank"
                          href="https://www.asu.edu/privacy/"
                        >
                          {' '}
                          if you do not wish to provide your consent.
                        </a>
                      </>
                    </li>
                  )}
                </ol>
                <p className="consent-reminder">
                  {this.state.termsandconditions.line5}
                </p>
                <p className="terms-paragraph">
                  {this.state.termsandconditions.line6}
                </p>
                <h2 className="terms-header">
                  {this.state.termsandconditions.heading2}
                </h2>
                <p className="terms-paragraph">
                  {this.state.termsandconditions.line7}
                </p>
                <h2 className="terms-header">
                  {this.state.termsandconditions.heading3}
                </h2>
                <p className="terms-paragraph">
                  {this.state.termsandconditions.line8}
                </p>
                <p className="terms-paragraph">
                  {this.state.termsandconditions.line9}
                </p>
                <ol className="bullets">
                  {this.state.termsandconditions.personalDataItems.map(
                    (item, index) => {
                      return (
                        <li
                          /* eslint-disable-next-line react/no-array-index-key */
                          key={`personal-data-item-${index}`}
                          className="terms-bullet-item"
                        >
                          ● {i18n.t(item)}
                        </li>
                      );
                    }
                  )}
                </ol>
                <h2 className="terms-header">
                  {this.state.termsandconditions.heading4}
                </h2>
                <p className="terms-paragraph">
                  {this.state.termsandconditions.line10}
                </p>
                <p className="terms-paragraph">
                  {this.state.termsandconditions.line11}
                </p>
                <p className="terms-paragraph" data-cy="terms-paragraph">
                  {this.state.termsandconditions.line12}
                </p>
                <p className="terms-paragraph">
                  {this.state.termsandconditions.line13}
                </p>
                <h2 className="terms-header">
                  {this.state.termsandconditions.heading5}
                </h2>
                <p className="terms-paragraph">
                  {this.state.termsandconditions.line14}
                </p>
                <p className="terms-paragraph">
                  {this.state.termsandconditions.line15}
                </p>
                <p className="cookie-paragraph">
                  <span className="cookie-header">
                    {this.state.termsandconditions.heading6}
                  </span>
                  {'. '}
                  {this.state.termsandconditions.line16}
                </p>
                <p className="cookie-paragraph">
                  <span className="cookie-header">
                    {this.state.termsandconditions.heading7}
                  </span>
                  {'. '}
                  {this.state.termsandconditions.line17}
                </p>
                <p className="cookie-paragraph">
                  <span className="cookie-header">
                    {this.state.termsandconditions.heading8}
                  </span>
                  {'. '}
                  {this.state.termsandconditions.line18}
                </p>
                <p className="cookie-paragraph">
                  <span className="cookie-header">
                    {this.state.termsandconditions.heading9}
                  </span>
                  {'. '}
                  {this.state.termsandconditions.line19}
                </p>
                <p className="cookie-paragraph">
                  <span className="cookie-header">
                    {this.state.termsandconditions.heading10}
                  </span>
                  {'. '}
                  {this.state.termsandconditions.line20}
                </p>
                <h2 className="terms-header">
                  {this.state.termsandconditions.heading11}
                </h2>
                <p className="terms-paragraph">
                  {this.state.termsandconditions.line21}
                </p>
                <p className="terms-paragraph">
                  {this.state.termsandconditions.line22}
                </p>
                <p className="terms-paragraph">
                  {this.state.termsandconditions.line23}
                </p>
                <p className="terms-paragraph">
                  {this.state.termsandconditions.line24}
                </p>
                <h2 className="terms-header">
                  {this.state.termsandconditions.heading12}
                </h2>
                <p className="terms-paragraph">
                  {this.state.termsandconditions.line25}
                </p>
                <p className="terms-paragraph">
                  {this.state.termsandconditions.line26}
                </p>
                <p className="terms-paragraph">
                  {this.state.termsandconditions.line27}
                </p>
                <p className="terms-paragraph">
                  {this.state.termsandconditions.line28}
                </p>
                <p className="terms-paragraph">
                  {this.state.termsandconditions.line29}
                </p>
                <p className="terms-closer first">
                  {this.getEffectiveDate(this.state)}
                  <br />
                  {this.getUpdatedDate(this.state)}
                </p>
              </div>

              <div className="check-container">
                <div className="column is-narrow consent-checkbox">
                  <label
                    className="checkbox-label"
                    htmlFor="agree-to-terms"
                    style={checkBoxColor}
                    ref={this.checkRef}
                  >
                    <input
                      className={this.props.classes.check}
                      type="checkbox"
                      id="agree-to-terms"
                      data-cy="agree-to-terms"
                      style={checkboxBorder}
                      onChange={this.handleTermsCheck}
                      onKeyDown={(e) => {
                        if (['Enter'].includes(e.key)) this.handleTermsCheck();
                      }}
                      checked={preregistration.agreedToTerms}
                    />
                    <span className="checkbox-text">
                      {this.state.termsandconditions.checkbox1}
                    </span>
                  </label>
                </div>
                <div className="column is-narrow narrow-column-checkbox" />
                <div className="column check-spacer" />
              </div>
            </Scrollbar>
          </div>
        </div>
        {/* -------------- Bottom Section -------------- */}
        <div className="terms-footer">
          <div className="mobile-scroll-prompt">
            {/* AXE is fine with this and this is how Bulma does it */}
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a
              className="checkbox-scroll-link"
              onClick={this.handleScrollDownSelect}
              onKeyDown={this.handleScrollDownSelect}
              role="link"
              tabIndex={0}
              style={scrollLinkTextColor}
            >
              {this.state.termsandconditions.mobileScrollPromptText}
            </a>
          </div>
          <div className="footer-horizontal-line-container">
            <div className="grey-horizontal-line" />
          </div>
          <button
            id="agree"
            data-cy="agree"
            className={[
              'button',
              'button--primary',
              'agree-button',
              this.getDynamicStyle(),
            ].join(' ')}
            disabled={!preregistration.agreedToTerms}
            onClick={this.goToGameExamplePage}
            type="button"
          >
            {t('Agree')}
          </button>
        </div>
      </div>
    );

    return (
      <Translation>
        {(t) => (
          <>
            <WindowTitle>{t('Terms and conditions')}</WindowTitle>
            <CampusBackground secondaryColor={tenant.secondary}>
              {getMainContent(t)}
            </CampusBackground>
          </>
        )}
      </Translation>
    );
  }
}

function mapStateToProps(state) {
  const tenant = getTenantState(state);
  const preregistration = getPreRegistrationState(state);

  return { tenant, preregistration };
}

export default withStyles(agreeButtonStyles)(
  withRouter(connect(mapStateToProps, { addTerms })(Terms))
);
